import { createContext, useContext } from 'react';

export const FormBuilderContext = createContext({
  autoSave: false,
  setAutoSave: () => {},
  saveButtonText: '',
  setSaveButtonText: () => {},
  breadCrumbs: [],
  setBreadCrumbs: () => {},
  initialBreadCrumbs: [],
  formik: {},
  enableNextTo: false,
  setEnableNextTo: () => {},
  setOpenModal: () => {},
  openModal: false,
  handleClose: () => {},
  formChange: () => {},
  form: {},
  setForm: () => {},
  searchTerm: '',
  setSearchTerm: () => {},
  debouncedSearchTerm: '',
  setDebouncedSearchTerm: () => {},
  isFormSavingLoading: false,
  handleSave: () => {},
  practiceId: null,
  isEdit: false,
  setIsEdit: () => {},
  showNavigationButtons: false,
  setShowNavigationButtons: () => {},
  viewFormModal: false,
  setViewFormModal: () => {},
  handleAutoSave: () => {},
  packetId: null,
  setPacketId: () => {},
  selectedLength: 0,
  setSelectedLength: () => {},
  isSaveAndExit: false,
  setIsSaveAndExit: () => {}
});

export const useFormBuilderContext = () => useContext(FormBuilderContext);
